import { render } from "./newDashboard.vue?vue&type=template&id=6576dd22&scoped=true"
import script from "./newDashboard.vue?vue&type=script&lang=js"
export * from "./newDashboard.vue?vue&type=script&lang=js"

import "./newDashboard.vue?vue&type=style&index=0&id=6576dd22&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6576dd22"]])

export default __exports__